/** Russian typography for the admin's own copy (pure; a copy of the public page's rules in
 *  miniapp-ui, plus the admin's no-break terms). Puts a no-break space (U+00A0):
 *  - after one- and two-letter prepositions and conjunctions (and «для»), so they never end a
 *    line: «в Telegram», «и видео»;
 *  - before a dash: «Адрес /x не найден — возможно…»;
 *  - between a number and the next word: «100 моделей»;
 *  - inside terms that must not break: «Telegram ID», «USDT TRC20», «… 2FA».
 *
 *  Applied by PageHeader, SectionHeader, EmptyState, ErrorState and Confirm to plain strings;
 *  data (names, codes, amounts) is never passed through it. */

const NBSP = '\u00a0'

/** A short word that is not part of a longer one (no letter or digit before it). */
const SHORT_WORD = /(?<![\p{L}\p{N}-])(в|и|с|к|о|у|а|на|по|до|из|от|не|за|для) /giu
const DASH = / — /g
const NUMBER_WORD = /(\d) (?=[\p{L}⚡₽$%])/gu
const TERMS = /\b(Telegram ID|USDT TRC20)\b/g
const TWO_FA = / (2FA)\b/g

export function typo(s: string): string {
  return s
    .replace(SHORT_WORD, `$1${NBSP}`)
    .replace(DASH, `${NBSP}— `)
    .replace(NUMBER_WORD, `$1${NBSP}`)
    .replace(TERMS, (t) => t.replace(' ', NBSP))
    .replace(TWO_FA, `${NBSP}$1`)
}

/** `typo` for a node that may be a plain string (titles, bodies); anything else as it is. */
export function typoNode<T>(v: T): T | string {
  return typeof v === 'string' ? typo(v) : v
}
